import { StackPageAction, StackPageFunctionName, State } from './types';
import { v4 as uuidv4 } from 'uuid';

export const stackReducer = (state: State, action: StackPageAction) => {
  switch (action.type) {
    case StackPageFunctionName.POP_STACK_PAGE_BY_ID:
      return {
        ...state,
        stack: state.stack.filter(({ id }) => id !== action.id),
      };
    case StackPageFunctionName.POP_STACK_PAGE_BY_NAME:
      return {
        ...state,
        stack: state.stack.filter(
          ({ stackPageName }) => stackPageName !== action.stackPageName
        ),
      };
    case StackPageFunctionName.PUSH_STACK_PAGE:
      return {
        ...state,
        stack: [
          ...state.stack,
          {
            id: uuidv4(),
            StackPage: action.page,
            ...(action.options || {}),
          },
        ],
      };
  }
};
